<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="formGroups" :viewMode="viewMode">
    </MyForm>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <CancelBtn :mode="mode" @onCancel="cancel"></CancelBtn>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import staffDetailMixin from "../mixin/detail";

export default {
  name: "MainAccountantDetail",
  mixins: [detailMixin, staffDetailMixin],
  data() {
    return {
      breadcrumb: [
        { name: "人员管理", path: "/staff/mainAccountant" },
        { name: "主管会计管理", path: "/staff/mainAccountant" },
        { name: "添加主管会计" },
      ],
    };
  },
  methods: {},
  created() {
    this.form['user_group_id'] = 2
    this.getOptions();
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
